export class MissingChatSocketError extends Error {
  constructor() {
    super('Chat socket is not registered. Call registerChatSocket first.');
    this.name = 'MissingChatSocketError';
  }
}

export class MissingMediaModuleClientError extends Error {
  constructor() {
    super('Media module axios instance is not registered. Call registerMediaModuleAxiosInstance first.');
    this.name = 'MissingMediaModuleClientError';
  }
}

export class MissingNodeApiClientError extends Error {
  constructor() {
    super('Node API axios instance is not registered. Call registerNodeApiAxiosInstance first.');
    this.name = 'MissingNodeApiClientError';
  }
}
